import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

const commonStylesProps = {
  className: st.SettingItem,
  titleClassName: st.SettingItem__Title,
  contentClassName: st.SettingItem__Content,
};

export function FacecoverTargetsSubForm({
  fieldName,
  targetsConfig,
}) {
  const { t } = useTranslation();
  const { register, formState: { errors } } = useFormContext();

  const createFullName = (name) => (fieldName ? `${fieldName}.${name}` : name);

  const targetsField = useWatch({
    name: createFullName('parameters.targets'),
    defaultValue: [],
  }) || [];

  return (
    <React.Fragment>
      {targetsConfig.map((target) => {
        const isActive = targetsField.includes(target.key);

        return (
          <React.Fragment key={target.key}>
            <SettingsItemWrapper
              title={t(target.titleI18nKey)}
              {...commonStylesProps}
            >
              <Control.Checkbox
                id={createFullName(`parameters.targets.${target.key}`)}
                label={t(`videoAnalytics:form.${isActive ? 'enabled' : 'disabled'}`)}
                value={target.key}
                {...register(createFullName('parameters.targets'))}
              />
            </SettingsItemWrapper>

            <SettingsItemWrapper
              data-tooltip-content={t(target.thresholdTooltipI18nKey)}
              title={t(target.thresholdLabelI18nKey)}
              {...commonStylesProps}
            >
              <Control.Input
                {...register(
                  createFullName(`parameters.parameters.${target.thresholdField}`),
                  {
                    min: validate.gte(0),
                    max: validate.lte(1),
                    validate: validate.number(),
                  },
                )}
                disabled={!isActive}
                errors={errors}
              />
            </SettingsItemWrapper>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
}
